var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffortlessIntegrationImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 360,
    viewBox: "0 0 491 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.102 403.62H253.302C256.162 403.62 258.803 402.1 260.233 399.62L280.332 364.81C281.762 362.33 281.762 359.29 280.332 356.81L260.233 322C258.803 319.52 256.162 318 253.302 318H213.102C210.242 318 207.603 319.52 206.173 322L186.072 356.81C184.643 359.29 184.643 362.33 186.072 364.81L206.173 399.62C207.603 402.1 210.242 403.62 213.102 403.62Z",
    fill: "url(#paint0_linear_1_150)",
    fillOpacity: 0.2,
    stroke: "url(#paint1_linear_1_150)",
    strokeWidth: 1.52,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.11 -23.99C28.76 -23.99 30.45 -23.96 32.12 -23.91C32.73 -23.89 33.22 -23.4 33.28 -22.75C33.36 -21.87 33.46 -20.92 33.57 -19.99C33.63 -19.52 33.98 -18.96 34.53 -18.79C36.17 -18.27 37.63 -17.63 38.99 -16.81L39.57 -16.46L40.11 -16.88L40.84 -17.44C41.39 -17.87 41.93 -18.28 42.47 -18.7C42.75 -18.92 43.05 -19.03 43.34 -19.03C43.63 -19.03 43.91 -18.91 44.16 -18.67C45.42 -17.45 46.7 -16.13 48.08 -14.66C48.46 -14.26 48.44 -13.56 48.04 -13.05C47.46 -12.3 46.86 -11.58 46.31 -10.92C45.76 -10.27 45.91 -9.64999 46.12 -9.25999C46.77 -8.05999 47.29 -6.73999 47.67 -5.31999C47.88 -4.51999 48.46 -4.29 48.9 -4.25C49.69 -4.16 50.5 -4.05 51.29 -3.95L51.67 -3.89999C52.44 -3.78999 52.86 -3.32999 52.87 -2.57999C52.87 -1.43999 52.85 -0.279993 52.83 0.850006L52.81 1.85001C52.81 2.30001 52.79 2.66001 52.76 2.98001C52.7 3.65001 52.09 4.01001 51.55 4.06001L50.62 4.16C50 4.22 49.37 4.29001 48.75 4.34001C48.12 4.39001 47.68 4.75001 47.51 5.35001C47.12 6.70001 46.54 8.04001 45.78 9.34001C45.46 9.88001 45.5 10.45 45.89 10.94C46.34 11.51 46.78 12.08 47.22 12.66L47.71 13.3C48.2 13.94 48.15 14.6 47.58 15.16C46.35 16.36 45.12 17.56 43.89 18.76C43.58 19.06 43.25 19.22 42.91 19.22C42.61 19.22 42.29 19.09 41.98 18.84L41.82 18.71C41.16 18.18 40.47 17.63 39.82 17.07C39.7 16.96 39.31 16.64 38.76 16.64C38.49 16.64 38.23 16.71 37.95 16.86C36.74 17.51 35.42 18.03 34.01 18.39C33.21 18.59 32.98 19.17 32.93 19.62C32.8 20.76 32.66 21.76 32.53 22.68C32.41 23.46 32.01 23.84 31.26 23.85C30.88 23.85 30.5 23.85 30.12 23.85C29.39 23.85 28.66 23.84 27.92 23.83C27.45 23.83 26.97 23.82 26.5 23.81H26.42H26.26H26.11C25.99 23.81 25.88 23.81 25.76 23.8C25.09 23.73 24.63 23.26 24.56 22.57V22.48C24.45 21.47 24.34 20.45 24.25 19.44C24.17 18.53 23.49 18.25 23.27 18.15C22.03 17.63 20.73 17.06 19.43 16.47C19.19 16.36 18.97 16.31 18.75 16.31C18.42 16.31 18.11 16.43 17.81 16.66C17.21 17.14 16.61 17.6 16.01 18.07L15.43 18.52C15.14 18.75 14.82 18.87 14.53 18.87C14.09 18.87 13.75 18.61 13.54 18.4C12.38 17.21 11.22 16.03 10.07 14.83C9.31998 14.06 9.29998 13.51 9.97998 12.68L10.24 12.36C10.76 11.71 11.28 11.07 11.81 10.43C12.2 9.96001 12.28 9.43 12.04 8.86C11.51 7.61 11 6.33001 10.5 5.09001C10.27 4.52001 9.86998 4.2 9.28998 4.13C8.48998 4.04 7.69999 3.93001 6.89999 3.82001L5.97998 3.69C5.46998 3.62 4.97999 3.06001 4.98999 2.54001C4.99999 0.520008 5.02998 -1.26999 5.06998 -2.92999C5.08998 -3.67999 5.51998 -4.14 6.28998 -4.23C7.25998 -4.34 8.22999 -4.43999 9.14999 -4.51999C10.02 -4.59999 10.35 -5.16 10.48 -5.62C10.85 -6.98 11.39 -8.28 12.07 -9.5C12.39 -10.07 12.34 -10.64 11.94 -11.15C11.32 -11.94 10.69 -12.75 10.09 -13.56C9.71 -14.07 9.74 -14.73 10.16 -15.16C11.49 -16.51 12.84 -17.82 14.15 -19.06C14.43 -19.32 14.74 -19.38 14.95 -19.38C15.23 -19.38 15.52 -19.28 15.76 -19.1C16.15 -18.8 16.54 -18.48 16.92 -18.17C17.29 -17.87 17.65 -17.57 18.02 -17.28C18.27 -17.08 18.62 -16.97 18.95 -16.97C19.16 -16.97 19.36 -17.02 19.54 -17.12C21.06 -17.95 22.59 -18.56 24.21 -18.99L24.86 -19.16L24.95 -19.83L25.07 -20.72C25.16 -21.44 25.26 -22.15 25.35 -22.87C25.44 -23.56 25.93 -24.03 26.57 -24.03H27.13M28.99 9.61C29.14 9.61 29.3 9.61 29.45 9.60001C32.18 9.47001 34.68 8.29001 36.47 6.28001C38.25 4.28001 39.12 1.7 38.94 -0.979996C38.58 -6.15 34.24 -10.2 29.07 -10.2C28.84 -10.2 28.6 -10.2 28.37 -10.18C25.73 -9.98999 23.31 -8.77 21.56 -6.73C19.83 -4.72 19 -2.18999 19.2 0.400009C19.62 5.64001 23.83 9.60001 29 9.60001M70.32 -1.78C70.42 -1.78 70.53 -1.77 70.63 -1.75L70.76 -1.73C71.42 -1.6 72.08 -1.47999 72.74 -1.34999C73.45 -1.20999 73.87 -0.669987 73.82 0.0600128C73.82 0.160013 73.8 0.26001 73.78 0.37001C73.72 0.77001 73.63 1.32001 73.89 1.84001C74.15 2.35001 74.63 2.59001 74.98 2.76001C75.08 2.81001 75.17 2.85 75.26 2.91L75.31 2.94C75.85 3.3 76.35 3.65 76.83 4.02C76.94 4.11 77.28 4.37001 77.76 4.37001C78.03 4.37001 78.28 4.29 78.54 4.13C78.8 3.97001 79.08 3.83001 79.41 3.68001C79.61 3.59001 79.8 3.54001 80 3.54001C80.38 3.54001 80.72 3.72001 80.96 4.04001C81.45 4.69001 81.9 5.36001 82.32 6.03001C82.66 6.57001 82.58 7.15001 82.09 7.62001C81.83 7.88001 81.53 8.12001 81.25 8.35001C80.92 8.62001 80.57 9.09001 80.75 9.85001C80.98 10.83 81.16 11.7 81.3 12.51C81.41 13.14 81.77 13.55 82.38 13.72C82.76 13.83 83.13 13.95 83.49 14.08C84.06 14.29 84.38 14.8 84.29 15.39C84.18 16.2 84.02 16.99 83.86 17.73C83.73 18.37 83.24 18.77 82.58 18.77C82.53 18.77 82.48 18.77 82.43 18.77C82.28 18.76 82.12 18.75 81.97 18.74C81.78 18.74 81.6 18.72 81.42 18.7C81.34 18.69 81.26 18.68 81.19 18.68C80.45 18.68 80.12 19.21 79.99 19.41C79.41 20.32 78.92 21.05 78.45 21.71C78.11 22.19 78.06 22.68 78.31 23.22C78.38 23.37 78.45 23.51 78.52 23.66C78.73 24.08 78.92 24.49 79.02 24.87C79.11 25.19 79.1 25.59 78.46 26.05C77.74 26.57 77.14 26.97 76.59 27.32C76.38 27.45 76.14 27.52 75.9 27.52C75.57 27.52 75.26 27.39 75.03 27.15C74.74 26.85 74.47 26.53 74.15 26.14C73.85 25.77 73.47 25.59 73.03 25.59C72.9 25.59 72.77 25.61 72.63 25.64C72.09 25.76 71.55 25.87 71.01 25.97C70.61 26.05 70.21 26.12 69.81 26.21C69.34 26.31 68.92 26.66 68.75 27.09C68.63 27.41 68.53 27.73 68.44 28.03C68.4 28.16 68.36 28.28 68.32 28.41C68.12 29.02 67.69 29.36 67.1 29.36C67 29.36 66.9 29.36 66.8 29.33C66.08 29.2 65.35 29.06 64.63 28.92C63.98 28.79 63.61 28.34 63.58 27.66L63.6 27.31C63.62 26.96 63.64 26.6 63.67 26.24C63.74 25.62 63.5 25.14 62.96 24.8C62.26 24.36 61.55 23.89 60.79 23.35C60.51 23.16 60.23 23.06 59.94 23.06C59.69 23.06 59.45 23.13 59.2 23.27C58.94 23.42 58.67 23.55 58.41 23.69L58.14 23.83C57.9 23.95 57.66 24.02 57.44 24.02C56.93 24.02 56.59 23.7 56.39 23.43C55.94 22.82 55.48 22.18 55.07 21.54C54.73 21 54.83 20.37 55.33 19.93C55.44 19.83 55.56 19.73 55.67 19.64C55.92 19.43 56.18 19.21 56.43 18.96C56.77 18.63 56.94 18.07 56.84 17.61C56.76 17.2 56.67 16.78 56.57 16.37C56.48 15.95 56.38 15.52 56.3 15.1C56.15 14.34 55.65 14.05 55.25 13.94C54.82 13.82 54.4 13.69 53.98 13.55C53.33 13.34 53 12.77 53.12 12.11L53.2 11.67C53.31 11.09 53.41 10.51 53.53 9.93001C53.63 9.43001 53.94 8.84001 54.8 8.84001C54.86 8.84001 54.92 8.84001 55.01 8.85001C55.42 8.89001 55.83 8.93001 56.27 8.93001C56.78 8.93001 57.23 8.60001 57.44 8.27C57.72 7.85001 57.99 7.42001 58.26 6.99001C58.5 6.61001 58.74 6.23001 58.98 5.85001C59.31 5.34001 59.33 4.82001 59.06 4.31001L59.01 4.23001C58.76 3.77001 58.52 3.34001 58.37 2.90001C58.22 2.45001 58.39 1.93002 58.8 1.64001C59.44 1.18002 60.12 0.710011 60.81 0.26001C61.01 0.130011 61.24 0.0600128 61.47 0.0600128C61.79 0.0600128 62.09 0.180004 62.32 0.410004C62.59 0.680004 62.85 0.990007 63.12 1.32001C63.49 1.78001 63.94 1.88 64.24 1.88C64.37 1.88 64.51 1.86 64.66 1.83C65.73 1.57 66.68 1.36 67.57 1.19C68.22 1.06 68.62 0.690002 68.77 0.0800018C68.83 -0.169998 68.92 -0.419987 69.01 -0.689987L69.06 -0.829987C69.26 -1.41999 69.7 -1.75999 70.28 -1.75999M68.77 20.6C68.91 20.6 69.06 20.6 69.21 20.59C72.91 20.37 75.82 17.2 75.69 13.53C75.56 9.74001 72.51 6.77 68.75 6.77C68.62 6.77 68.5 6.77001 68.37 6.78001C66.54 6.88001 64.85 7.69001 63.61 9.07001C62.37 10.46 61.74 12.25 61.85 14.1C62.07 17.81 65.04 20.6 68.77 20.6ZM46.74 24.66C47.43 24.66 47.89 25.06 48.02 25.77L48.07 26.03C48.17 26.54 48.27 27.07 48.39 27.6C48.49 28.03 48.87 28.53 49.41 28.66C50.48 28.92 51.73 29.26 52.9 29.86C53.07 29.95 53.26 29.99 53.46 29.99C53.8 29.99 54.14 29.87 54.42 29.64C54.82 29.3 55.24 28.96 55.62 28.54C55.83 28.3 56.19 28.02 56.66 28.02C57 28.02 57.35 28.17 57.69 28.47C57.98 28.72 58.26 28.97 58.55 29.21C59.14 29.72 59.73 30.22 60.31 30.75C60.84 31.23 60.89 31.86 60.46 32.48L60.41 32.56C60.07 33.05 59.72 33.55 59.4 34.07C59.12 34.52 59.16 35.09 59.34 35.45C59.57 35.94 59.81 36.43 60.05 36.92C60.34 37.51 60.63 38.1 60.91 38.69C61.18 39.26 61.63 39.55 62.25 39.57C62.92 39.58 63.59 39.62 64.23 39.66C64.81 39.7 65.28 40.18 65.33 40.77C65.42 41.96 65.51 43.14 65.59 44.33C65.66 45.27 65.27 45.76 64.32 45.92C63.75 46.01 63.17 46.11 62.58 46.25C62.12 46.36 61.69 46.75 61.53 47.21C61.33 47.79 61.13 48.38 60.93 48.96C60.74 49.53 60.55 50.09 60.35 50.66C60.14 51.25 60.25 51.77 60.67 52.2C60.99 52.53 61.31 52.87 61.62 53.22L62 53.64C62.53 54.22 62.54 54.87 62.02 55.47L61.31 56.3C60.78 56.91 60.25 57.53 59.72 58.14C59.42 58.48 59.09 58.65 58.74 58.65C58.47 58.65 58.19 58.55 57.9 58.36L56.55 57.45L56.08 57.13L55.61 56.81L55.1 57.05L54.27 57.43C53.29 57.88 52.34 58.32 51.4 58.76C50.96 58.97 50.62 59.45 50.58 59.93C50.55 60.28 50.54 60.63 50.52 60.98C50.5 61.41 50.48 61.82 50.44 62.23C50.37 62.92 49.95 63.33 49.26 63.4C47.97 63.52 46.77 63.6 45.61 63.66H45.51C44.64 63.66 44.34 63.07 44.24 62.57C44.1 61.88 43.97 61.2 43.85 60.51C43.74 59.87 43.35 59.44 42.71 59.24C42.09 59.05 41.47 58.83 40.86 58.62C40.42 58.47 39.99 58.32 39.55 58.17C39.41 58.12 39.25 58.1 39.09 58.1C38.72 58.1 38.37 58.22 38.13 58.44C37.8 58.72 37.49 59.02 37.17 59.31C36.95 59.51 36.74 59.71 36.52 59.91C36.21 60.18 35.9 60.32 35.59 60.32C35.28 60.32 34.98 60.19 34.68 59.93C33.78 59.16 32.88 58.38 31.99 57.6C31.43 57.11 31.36 56.56 31.75 55.93C32.17 55.26 32.62 54.6 33.01 54.03C33.34 53.55 33.36 53.05 33.08 52.52C32.55 51.53 32.08 50.64 31.66 49.73C31.37 49.11 30.88 48.79 30.2 48.77H30.13C29.45 48.74 28.76 48.72 28.08 48.67C27.45 48.63 26.99 48.17 26.93 47.53C26.84 46.36 26.75 45.19 26.67 44.01C26.6 43.06 26.98 42.58 27.93 42.41C28.17 42.37 28.41 42.32 28.65 42.28C28.97 42.22 29.28 42.16 29.6 42.11C30.26 42 30.69 41.6 30.88 40.94C31.16 39.94 31.49 38.89 31.9 37.72C32.12 37.1 32 36.55 31.56 36.09C31.05 35.56 30.6 35.07 30.18 34.59C29.78 34.14 29.76 33.46 30.12 33.02C30.93 32.04 31.79 31.05 32.67 30.07C32.91 29.81 33.21 29.67 33.53 29.67C33.76 29.67 34 29.74 34.23 29.88C34.81 30.25 35.37 30.64 35.8 30.95C36.08 31.15 36.37 31.25 36.67 31.25C37 31.25 37.27 31.13 37.44 31.04C38.5 30.47 39.61 29.9 40.76 29.35C41 29.23 41.73 28.88 41.73 27.88C41.73 27.35 41.76 26.82 41.79 26.26V26.19C41.83 25.49 42.31 25 43.01 24.95C44.21 24.86 45.41 24.77 46.61 24.69C46.65 24.69 46.69 24.69 46.74 24.69M46.19 52.31C46.38 52.31 46.57 52.31 46.76 52.29C51.32 51.98 54.79 48.01 54.48 43.45C54.19 39.13 50.56 35.74 46.21 35.74C46.02 35.74 45.83 35.74 45.65 35.76C43.45 35.91 41.44 36.91 39.99 38.58C38.54 40.25 37.82 42.38 37.97 44.58C38.27 48.91 41.88 52.31 46.2 52.31M27.11 -24.99C26.92 -24.99 26.74 -24.99 26.55 -24.99C25.39 -24.99 24.49 -24.12 24.34 -22.96C24.21 -21.95 24.08 -20.94 23.95 -19.92C22.22 -19.47 20.59 -18.81 19.05 -17.96C19.02 -17.94 18.98 -17.94 18.94 -17.94C18.83 -17.94 18.7 -17.98 18.63 -18.04C17.87 -18.64 17.13 -19.27 16.36 -19.86C15.94 -20.19 15.44 -20.35 14.94 -20.35C14.4 -20.35 13.88 -20.16 13.46 -19.76C12.1 -18.48 10.76 -17.17 9.44998 -15.84C8.66998 -15.05 8.61998 -13.84 9.28998 -12.94C9.89998 -12.12 10.52 -11.3 11.16 -10.5C11.31 -10.31 11.33 -10.17 11.21 -9.95999C10.48 -8.65999 9.93 -7.28999 9.53 -5.85999C9.46 -5.59999 9.33999 -5.51999 9.07999 -5.48999C8.10999 -5.40999 7.15 -5.30999 6.19 -5.18999C4.93 -5.03999 4.10999 -4.18 4.07999 -2.92C4.02999 -1.09 4.01 0.740007 4 2.57001C4 3.60001 4.85999 4.58001 5.85999 4.71001C6.96999 4.86001 8.08 5.02001 9.19 5.15001C9.43 5.18001 9.51 5.29001 9.59 5.48001C10.1 6.75001 10.6 8.02 11.13 9.27C11.23 9.5 11.2 9.63001 11.05 9.81001C10.43 10.56 9.81999 11.31 9.20999 12.07C8.21999 13.29 8.26999 14.41 9.35999 15.54C10.51 16.74 11.68 17.93 12.84 19.11C13.34 19.62 13.94 19.88 14.55 19.88C15.06 19.88 15.59 19.69 16.07 19.32C16.87 18.7 17.67 18.09 18.46 17.45C18.57 17.36 18.67 17.32 18.77 17.32C18.85 17.32 18.93 17.34 19.04 17.39C20.32 17.97 21.61 18.54 22.91 19.08C23.15 19.18 23.26 19.27 23.28 19.53C23.37 20.58 23.48 21.63 23.59 22.68C23.71 23.84 24.54 24.69 25.68 24.8C25.83 24.82 25.98 24.82 26.13 24.82C26.23 24.82 26.34 24.82 26.44 24.82C26.46 24.82 26.49 24.82 26.51 24.82C27.72 24.83 28.92 24.86 30.13 24.86C30.52 24.86 30.9 24.86 31.29 24.85C32.55 24.83 33.35 24.07 33.53 22.83C33.68 21.8 33.81 20.78 33.93 19.75C33.96 19.52 34.04 19.44 34.27 19.38C35.72 19.01 37.12 18.48 38.44 17.76C38.57 17.69 38.68 17.66 38.78 17.66C38.92 17.66 39.04 17.73 39.19 17.85C39.91 18.46 40.64 19.05 41.38 19.64C41.88 20.04 42.41 20.24 42.93 20.24C43.52 20.24 44.1 19.99 44.6 19.5C45.83 18.3 47.06 17.1 48.29 15.9C49.23 14.98 49.31 13.75 48.52 12.71C47.91 11.92 47.31 11.12 46.69 10.34C46.55 10.17 46.56 10.05 46.66 9.87001C47.44 8.54001 48.06 7.14001 48.49 5.65001C48.55 5.45001 48.65 5.37 48.86 5.36C49.8 5.28 50.74 5.17 51.67 5.08C52.76 4.97 53.68 4.19001 53.78 3.09001C53.82 2.69001 53.83 2.29001 53.84 1.89001C53.86 0.410015 53.9 -1.07 53.89 -2.56C53.89 -3.82 53.08 -4.7 51.83 -4.87C50.9 -4.99999 49.97 -5.13 49.03 -5.23C48.79 -5.26 48.71 -5.34999 48.66 -5.56999C48.28 -7.01999 47.74 -8.41 47.02 -9.73C46.9 -9.96 46.95 -10.09 47.1 -10.27C47.7 -10.98 48.29 -11.7 48.86 -12.43C49.55 -13.32 49.57 -14.56 48.84 -15.34C47.55 -16.72 46.24 -18.07 44.89 -19.38C44.44 -19.82 43.91 -20.03 43.38 -20.03C42.88 -20.03 42.37 -19.85 41.9 -19.49C41.12 -18.89 40.34 -18.29 39.53 -17.67C38.04 -18.56 36.48 -19.23 34.85 -19.75C34.73 -19.79 34.6 -19.99 34.58 -20.12C34.47 -21.03 34.38 -21.94 34.29 -22.85C34.18 -23.98 33.31 -24.88 32.17 -24.92C30.49 -24.97 28.81 -25 27.12 -25L27.11 -24.99ZM28.97 8.65001C24.46 8.65001 20.56 5.21001 20.17 0.37001C19.78 -4.47999 23.55 -8.78999 28.4 -9.12999C28.61 -9.14999 28.82 -9.14999 29.03 -9.14999C33.65 -9.14999 37.58 -5.54999 37.91 -0.859985C38.26 4.12001 34.48 8.41001 29.38 8.65001C29.24 8.65001 29.1 8.65001 28.97 8.65001ZM70.29 -2.73C69.29 -2.73 68.46 -2.12999 68.12 -1.10999C68.01 -0.779985 67.9 -0.449995 67.81 -0.119995C67.75 0.120005 67.64 0.190006 67.39 0.240005C66.4 0.430006 65.41 0.650015 64.43 0.890015C64.36 0.910015 64.3 0.920013 64.24 0.920013C64.11 0.920013 64 0.87001 63.9 0.730011C63.62 0.390011 63.34 0.0400105 63.02 -0.269989C62.59 -0.689989 62.03 -0.899994 61.47 -0.899994C61.05 -0.899994 60.63 -0.779993 60.26 -0.539993C59.56 -0.0899925 58.88 0.380011 58.2 0.87001C57.45 1.42001 57.11 2.39001 57.41 3.27C57.6 3.81001 57.88 4.33001 58.16 4.84001C58.27 5.05001 58.24 5.18001 58.12 5.35001C57.6 6.15001 57.1 6.96001 56.58 7.76001C56.51 7.86001 56.36 7.96001 56.25 7.96001C55.85 7.96001 55.45 7.92001 55.05 7.88C54.96 7.88 54.87 7.87001 54.78 7.87001C53.63 7.87001 52.77 8.57001 52.53 9.76001C52.38 10.49 52.25 11.23 52.12 11.96C51.91 13.11 52.54 14.16 53.65 14.53C54.08 14.67 54.52 14.81 54.96 14.94C55.17 15 55.26 15.1 55.3 15.33C55.46 16.17 55.67 17 55.84 17.84C55.87 17.98 55.8 18.19 55.7 18.29C55.37 18.62 55 18.91 54.64 19.23C53.79 19.99 53.59 21.17 54.2 22.13C54.62 22.8 55.09 23.43 55.55 24.07C56.03 24.73 56.69 25.07 57.4 25.07C57.78 25.07 58.18 24.97 58.56 24.77C58.93 24.58 59.3 24.4 59.66 24.19C59.75 24.14 59.83 24.11 59.9 24.11C59.99 24.11 60.07 24.15 60.18 24.22C60.9 24.73 61.64 25.22 62.39 25.69C62.6 25.82 62.67 25.93 62.64 26.18C62.58 26.72 62.57 27.26 62.54 27.7C62.58 28.88 63.29 29.72 64.39 29.95C65.12 30.1 65.85 30.24 66.59 30.37C66.75 30.4 66.91 30.41 67.06 30.41C68.08 30.41 68.9 29.8 69.23 28.76C69.36 28.34 69.48 27.91 69.64 27.5C69.68 27.38 69.85 27.26 69.97 27.24C70.92 27.04 71.87 26.88 72.81 26.67C72.88 26.65 72.93 26.65 72.98 26.65C73.12 26.65 73.22 26.71 73.33 26.84C73.63 27.2 73.94 27.56 74.26 27.9C74.69 28.35 75.27 28.58 75.85 28.58C76.27 28.58 76.7 28.46 77.07 28.22C77.72 27.81 78.36 27.36 78.99 26.91C79.76 26.36 80.18 25.61 79.94 24.66C79.77 24.03 79.44 23.44 79.17 22.85C79.08 22.65 79.08 22.53 79.21 22.34C79.75 21.57 80.27 20.79 80.77 19.99C80.87 19.83 80.95 19.73 81.12 19.73C81.15 19.73 81.17 19.73 81.21 19.73C81.56 19.78 81.93 19.78 82.29 19.81C82.37 19.81 82.45 19.82 82.53 19.82C83.65 19.82 84.56 19.1 84.79 17.99C84.96 17.19 85.11 16.39 85.23 15.58C85.38 14.52 84.79 13.56 83.78 13.19C83.39 13.05 82.99 12.92 82.59 12.81C82.37 12.75 82.27 12.65 82.23 12.4C82.07 11.49 81.88 10.58 81.67 9.68001C81.62 9.45001 81.66 9.33 81.83 9.19C82.14 8.94 82.45 8.68001 82.74 8.40001C83.56 7.61001 83.72 6.51001 83.12 5.56001C82.68 4.86001 82.21 4.17 81.71 3.5C81.27 2.91 80.62 2.59001 79.94 2.59001C79.6 2.59001 79.25 2.67 78.92 2.83C78.6 2.98 78.27 3.14 77.96 3.33C77.86 3.39 77.78 3.42001 77.7 3.42001C77.6 3.42001 77.51 3.37001 77.39 3.28001C76.87 2.87001 76.32 2.50001 75.77 2.12001C75.42 1.88001 74.9 1.75001 74.74 1.43001C74.57 1.10001 74.74 0.600014 74.78 0.170013C74.86 -1.05999 74.1 -2.04 72.89 -2.28C72.18 -2.42 71.48 -2.54999 70.77 -2.68999C70.6 -2.71999 70.43 -2.73999 70.27 -2.73999L70.29 -2.73ZM68.78 19.63C65.63 19.63 63.05 17.24 62.86 14.07C62.67 10.82 65.18 7.98001 68.43 7.81001C68.54 7.81001 68.65 7.81001 68.76 7.81001C72.1 7.81001 74.6 10.51 74.7 13.6C74.8 16.67 72.33 19.44 69.15 19.63C69.02 19.63 68.9 19.64 68.77 19.64L68.78 19.63ZM46.75 23.69C46.69 23.69 46.62 23.69 46.56 23.69C45.36 23.77 44.15 23.86 42.95 23.95C41.74 24.04 40.87 24.93 40.81 26.14C40.78 26.72 40.75 27.3 40.75 27.88C40.75 28.19 40.62 28.32 40.34 28.45C39.21 29 38.09 29.57 36.98 30.16C36.87 30.22 36.77 30.25 36.69 30.25C36.6 30.25 36.51 30.21 36.4 30.14C35.87 29.76 35.33 29.39 34.78 29.04C34.39 28.79 33.97 28.67 33.55 28.67C32.96 28.67 32.38 28.92 31.94 29.4C31.06 30.37 30.19 31.37 29.36 32.38C28.67 33.21 28.72 34.43 29.43 35.25C29.89 35.77 30.36 36.28 30.83 36.78C31.01 36.97 31.04 37.13 30.95 37.4C30.57 38.48 30.22 39.58 29.91 40.68C29.83 40.98 29.7 41.09 29.43 41.13C28.87 41.22 28.31 41.33 27.75 41.43C26.29 41.69 25.56 42.62 25.67 44.09C25.75 45.27 25.84 46.44 25.93 47.61C26.02 48.74 26.87 49.59 28.01 49.67C28.73 49.72 29.45 49.74 30.17 49.77C30.45 49.78 30.62 49.86 30.76 50.16C31.21 51.12 31.71 52.06 32.21 53C32.31 53.19 32.32 53.3 32.21 53.47C31.77 54.11 31.34 54.75 30.93 55.41C30.27 56.46 30.43 57.55 31.35 58.36C32.24 59.15 33.14 59.93 34.05 60.7C34.54 61.12 35.08 61.33 35.61 61.33C36.14 61.33 36.71 61.11 37.21 60.66C37.75 60.18 38.26 59.67 38.8 59.2C38.87 59.14 39 59.11 39.11 59.11C39.16 59.11 39.21 59.11 39.25 59.13C40.31 59.48 41.36 59.88 42.43 60.2C42.72 60.29 42.83 60.42 42.88 60.69C43 61.39 43.13 62.08 43.27 62.77C43.5 63.95 44.35 64.67 45.52 64.67C45.57 64.67 45.62 64.67 45.66 64.67C46.89 64.61 48.12 64.52 49.35 64.41C50.51 64.31 51.32 63.52 51.44 62.35C51.52 61.58 51.52 60.8 51.58 60.03C51.59 59.9 51.72 59.74 51.83 59.68C53.03 59.11 54.23 58.56 55.52 57.97C56.05 58.33 56.69 58.76 57.34 59.2C57.8 59.51 58.27 59.66 58.74 59.66C59.37 59.66 59.98 59.37 60.47 58.81C61.25 57.93 62.01 57.03 62.78 56.14C63.63 55.16 63.61 53.94 62.74 52.99C62.29 52.5 61.85 52 61.39 51.52C61.22 51.35 61.23 51.23 61.3 51.02C61.7 49.87 62.07 48.72 62.48 47.57C62.53 47.44 62.68 47.28 62.82 47.25C63.37 47.12 63.93 47.03 64.49 46.93C65.94 46.69 66.69 45.74 66.59 44.29C66.51 43.1 66.42 41.91 66.33 40.72C66.24 39.64 65.39 38.77 64.31 38.69C63.63 38.64 62.96 38.61 62.28 38.59C62.04 38.59 61.93 38.51 61.82 38.29C61.31 37.2 60.76 36.13 60.25 35.05C60.19 34.93 60.19 34.73 60.25 34.63C60.58 34.1 60.94 33.59 61.29 33.08C62 32.06 61.9 30.87 60.99 30.04C60.13 29.26 59.24 28.51 58.36 27.75C57.81 27.27 57.23 27.06 56.67 27.06C56.01 27.06 55.38 27.36 54.89 27.9C54.55 28.28 54.15 28.61 53.76 28.93C53.7 28.98 53.58 29.02 53.48 29.02C53.44 29.02 53.4 29.02 53.37 29C52.19 28.39 50.93 28.02 49.65 27.71C49.54 27.68 49.4 27.52 49.37 27.39C49.23 26.8 49.12 26.2 49.01 25.6C48.78 24.42 47.91 23.68 46.74 23.68L46.75 23.69ZM46.2 51.31C42.43 51.31 39.24 48.36 38.97 44.51C38.69 40.52 41.73 37.03 45.73 36.76C45.9 36.75 46.06 36.74 46.23 36.74C50 36.74 53.25 39.71 53.5 43.51C53.77 47.53 50.73 51.01 46.71 51.28C46.54 51.29 46.38 51.3 46.21 51.3L46.2 51.31Z",
    fill: "url(#paint2_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M181.28 187.57H181.84C182.48 187.57 182.97 188.04 183.06 188.73C183.15 189.42 183.24 190.12 183.33 190.81L183.46 191.77L183.55 192.44L184.2 192.61C185.83 193.03 187.36 193.65 188.87 194.48C189.05 194.58 189.24 194.63 189.46 194.63C189.79 194.63 190.14 194.51 190.39 194.32C190.76 194.03 191.13 193.73 191.49 193.43C191.88 193.12 192.26 192.8 192.65 192.5C192.89 192.32 193.17 192.22 193.46 192.22C193.67 192.22 193.98 192.28 194.26 192.54C195.57 193.77 196.91 195.08 198.25 196.44C198.67 196.87 198.7 197.53 198.32 198.04C197.71 198.86 197.09 199.67 196.47 200.45C196.06 200.96 196.02 201.53 196.34 202.1C197.02 203.31 197.55 204.62 197.93 205.98C198.06 206.44 198.39 207 199.26 207.08C200.19 207.16 201.15 207.26 202.12 207.37C202.89 207.46 203.32 207.92 203.34 208.67C203.38 210.33 203.41 212.12 203.42 214.14C203.42 214.66 202.94 215.22 202.43 215.29L201.5 215.42C200.71 215.53 199.91 215.64 199.12 215.73C198.54 215.8 198.14 216.12 197.91 216.69C197.42 217.93 196.91 219.21 196.37 220.46C196.13 221.03 196.2 221.56 196.6 222.03C197.13 222.67 197.65 223.32 198.18 223.96L198.43 224.27C199.11 225.1 199.08 225.65 198.34 226.42C197.19 227.61 196.03 228.8 194.87 229.99C194.66 230.21 194.31 230.46 193.88 230.46C193.58 230.46 193.27 230.34 192.98 230.11L192.41 229.67C191.81 229.2 191.2 228.74 190.6 228.26C190.3 228.02 190 227.91 189.66 227.91C189.44 227.91 189.22 227.96 188.98 228.07C187.67 228.67 186.38 229.23 185.14 229.75C184.92 229.84 184.24 230.13 184.16 231.04C184.07 232.05 183.97 233.07 183.86 234.08V234.17C183.78 234.86 183.32 235.33 182.65 235.4C182.54 235.41 182.42 235.41 182.3 235.41H182.15H181.99H181.91C181.44 235.41 180.96 235.42 180.49 235.43C179.76 235.44 179.03 235.45 178.29 235.45C177.91 235.45 177.53 235.45 177.15 235.45C176.4 235.44 176 235.06 175.88 234.28C175.75 233.37 175.61 232.37 175.48 231.22C175.43 230.77 175.2 230.2 174.4 229.99C172.99 229.63 171.67 229.11 170.46 228.46C170.18 228.31 169.92 228.24 169.65 228.24C169.1 228.24 168.72 228.56 168.59 228.67C167.94 229.23 167.25 229.77 166.59 230.31L166.42 230.44C166.11 230.69 165.8 230.82 165.49 230.82C165.16 230.82 164.83 230.67 164.51 230.36C163.28 229.16 162.05 227.97 160.82 226.76C160.24 226.2 160.2 225.53 160.69 224.9L161.19 224.25C161.63 223.68 162.06 223.11 162.51 222.54C162.9 222.05 162.93 221.49 162.62 220.94C161.86 219.64 161.28 218.3 160.89 216.95C160.72 216.35 160.27 215.99 159.65 215.94C159.03 215.89 158.41 215.82 157.79 215.76L156.86 215.66C156.32 215.61 155.7 215.24 155.65 214.58C155.62 214.26 155.6 213.9 155.6 213.45L155.58 212.45C155.56 211.33 155.54 210.16 155.54 209.03C155.54 208.28 155.97 207.81 156.74 207.71L157.12 207.66C157.9 207.55 158.71 207.44 159.51 207.36C159.96 207.31 160.53 207.09 160.74 206.29C161.12 204.88 161.64 203.55 162.29 202.35C162.51 201.95 162.65 201.34 162.1 200.69C161.54 200.02 160.94 199.3 160.37 198.56C159.97 198.05 159.95 197.35 160.33 196.95C161.71 195.48 162.99 194.16 164.25 192.94C164.5 192.7 164.77 192.58 165.07 192.58C165.37 192.58 165.66 192.69 165.94 192.91C166.48 193.32 167.02 193.74 167.56 194.16L168.3 194.73L168.84 195.15L169.42 194.8C170.78 193.98 172.24 193.34 173.88 192.82C174.43 192.65 174.78 192.08 174.84 191.62C174.96 190.69 175.05 189.74 175.13 188.86C175.19 188.21 175.68 187.72 176.29 187.7C177.96 187.65 179.65 187.62 181.3 187.62M179.44 221.26C184.6 221.26 188.81 217.31 189.24 212.06C189.45 209.47 188.61 206.94 186.88 204.93C185.13 202.89 182.71 201.67 180.07 201.48C179.83 201.46 179.6 201.46 179.37 201.46C174.2 201.46 169.86 205.51 169.5 210.68C169.31 213.36 170.19 215.94 171.97 217.94C173.76 219.95 176.25 221.13 178.99 221.26C179.14 221.26 179.3 221.27 179.45 221.27M138.13 209.89C138.71 209.89 139.15 210.23 139.35 210.82L139.4 210.96C139.49 211.23 139.58 211.49 139.64 211.73C139.79 212.34 140.19 212.71 140.84 212.84C141.73 213.01 142.68 213.22 143.75 213.48C143.9 213.52 144.04 213.53 144.18 213.53C144.49 213.53 144.93 213.43 145.3 212.97C145.56 212.64 145.82 212.33 146.1 212.06C146.33 211.84 146.63 211.71 146.95 211.71C147.19 211.71 147.41 211.78 147.61 211.91C148.31 212.36 148.98 212.82 149.62 213.29C150.03 213.59 150.21 214.1 150.05 214.55C149.9 214.98 149.66 215.42 149.41 215.88L149.36 215.96C149.08 216.47 149.11 216.99 149.44 217.5C149.68 217.88 149.92 218.26 150.16 218.64C150.43 219.07 150.7 219.49 150.98 219.92C151.19 220.25 151.64 220.58 152.15 220.58C152.59 220.58 153.01 220.54 153.44 220.5C153.5 220.5 153.56 220.5 153.62 220.5C154.49 220.5 154.79 221.09 154.89 221.59C155.01 222.17 155.12 222.75 155.22 223.34L155.3 223.77C155.42 224.43 155.08 225 154.44 225.21C154.02 225.35 153.6 225.48 153.17 225.6C152.77 225.71 152.26 226 152.12 226.76C152.04 227.19 151.94 227.61 151.85 228.03C151.76 228.44 151.67 228.85 151.58 229.27C151.49 229.73 151.66 230.29 152 230.62C152.25 230.87 152.51 231.09 152.76 231.3C152.87 231.4 152.99 231.49 153.1 231.59C153.6 232.03 153.7 232.66 153.36 233.2C152.95 233.84 152.49 234.48 152.04 235.09C151.85 235.36 151.51 235.68 151 235.68C150.77 235.68 150.54 235.62 150.3 235.49L150.03 235.35C149.76 235.21 149.5 235.08 149.24 234.93C148.99 234.79 148.75 234.72 148.5 234.72C148.2 234.72 147.92 234.81 147.65 235.01C146.89 235.54 146.19 236.01 145.48 236.45C144.94 236.79 144.7 237.28 144.77 237.89C144.81 238.24 144.83 238.61 144.84 238.96L144.86 239.31C144.83 239.99 144.45 240.44 143.81 240.57C143.09 240.72 142.37 240.86 141.64 240.98C141.54 241 141.44 241.01 141.34 241.01C140.75 241.01 140.32 240.67 140.12 240.06C140.08 239.94 140.04 239.81 140 239.68C139.91 239.37 139.81 239.06 139.69 238.73C139.52 238.3 139.1 237.95 138.63 237.85C138.23 237.77 137.83 237.69 137.43 237.61C136.89 237.51 136.35 237.4 135.81 237.28C135.67 237.25 135.54 237.23 135.41 237.23C134.97 237.23 134.6 237.42 134.29 237.78C134.03 238.1 133.72 238.46 133.41 238.79C133.18 239.03 132.87 239.16 132.54 239.16C132.3 239.16 132.06 239.09 131.85 238.96C131.3 238.61 130.71 238.21 129.98 237.69C129.33 237.23 129.33 236.83 129.42 236.51C129.52 236.12 129.72 235.72 129.92 235.3C129.99 235.16 130.06 235.01 130.13 234.87C130.38 234.33 130.34 233.84 129.99 233.36C129.52 232.7 129.03 231.97 128.45 231.06C128.32 230.86 127.99 230.33 127.25 230.33C127.18 230.33 127.1 230.33 127.02 230.35C126.84 230.38 126.65 230.39 126.47 230.39C126.31 230.39 126.16 230.41 126.01 230.42C125.96 230.42 125.91 230.42 125.86 230.42C125.2 230.42 124.71 230.02 124.58 229.38C124.43 228.64 124.27 227.84 124.15 227.04C124.07 226.45 124.38 225.94 124.95 225.73C125.3 225.6 125.68 225.48 126.06 225.37C126.67 225.2 127.03 224.8 127.14 224.17C127.28 223.36 127.46 222.49 127.69 221.51C127.87 220.75 127.51 220.28 127.19 220.01C126.91 219.78 126.61 219.54 126.35 219.28C125.87 218.81 125.78 218.23 126.12 217.69C126.54 217.02 127 216.35 127.48 215.7C127.72 215.38 128.06 215.2 128.44 215.2C128.64 215.2 128.84 215.25 129.03 215.34C129.35 215.49 129.64 215.63 129.9 215.79C130.16 215.95 130.42 216.03 130.68 216.03C131.16 216.03 131.5 215.77 131.61 215.68C132.09 215.3 132.59 214.96 133.12 214.6L133.17 214.56C133.25 214.5 133.35 214.46 133.45 214.41C133.8 214.24 134.28 214 134.54 213.49C134.8 212.97 134.71 212.42 134.65 212.02C134.63 211.92 134.62 211.81 134.61 211.71C134.56 210.98 134.98 210.44 135.7 210.3C136.35 210.17 137 210.05 137.65 209.93L137.81 209.9C137.92 209.88 138.02 209.87 138.12 209.87M139.63 232.23C143.35 232.23 146.33 229.43 146.55 225.73C146.66 223.88 146.04 222.1 144.79 220.7C143.55 219.32 141.87 218.5 140.03 218.41C139.9 218.41 139.77 218.4 139.65 218.4C135.88 218.4 132.84 221.37 132.71 225.16C132.59 228.83 135.5 232 139.19 232.22C139.34 232.22 139.48 232.23 139.63 232.23ZM161.66 236.29C161.66 236.29 161.74 236.29 161.79 236.29C162.99 236.37 164.19 236.46 165.39 236.55C166.09 236.6 166.57 237.09 166.61 237.79V237.86C166.64 238.42 166.67 238.95 166.67 239.48C166.67 240.49 167.4 240.84 167.64 240.96C168.78 241.51 169.9 242.08 170.96 242.65C171.13 242.74 171.39 242.86 171.73 242.86C172.03 242.86 172.32 242.76 172.6 242.56C173.02 242.26 173.59 241.86 174.17 241.49C174.39 241.35 174.63 241.28 174.87 241.28C175.2 241.28 175.5 241.42 175.73 241.68C176.62 242.66 177.48 243.65 178.28 244.63C178.65 245.07 178.62 245.75 178.22 246.2C177.8 246.68 177.35 247.17 176.84 247.7C176.4 248.16 176.29 248.71 176.5 249.33C176.91 250.5 177.24 251.56 177.52 252.55C177.71 253.22 178.13 253.61 178.8 253.72C179.12 253.77 179.44 253.83 179.75 253.89C179.99 253.93 180.23 253.98 180.47 254.02C181.42 254.19 181.8 254.67 181.73 255.62C181.65 256.79 181.56 257.96 181.47 259.14C181.42 259.78 180.96 260.24 180.32 260.28C179.64 260.33 178.95 260.35 178.27 260.37H178.2C177.52 260.4 177.03 260.72 176.74 261.34C176.32 262.25 175.85 263.14 175.32 264.13C175.04 264.66 175.06 265.17 175.38 265.64C175.86 266.34 176.26 266.94 176.64 267.54C177.04 268.17 176.96 268.72 176.4 269.21C175.51 269.99 174.61 270.77 173.71 271.54C173.41 271.8 173.1 271.93 172.8 271.93C172.5 271.93 172.18 271.79 171.87 271.52C171.65 271.32 171.43 271.12 171.22 270.92C170.9 270.63 170.59 270.33 170.26 270.05C170.01 269.84 169.66 269.72 169.3 269.72C169.14 269.72 168.99 269.74 168.84 269.79C168.4 269.93 167.97 270.09 167.53 270.24C166.92 270.45 166.29 270.67 165.68 270.86C165.03 271.06 164.65 271.49 164.54 272.13C164.42 272.82 164.29 273.5 164.15 274.19C164.05 274.69 163.75 275.29 162.88 275.29H162.78C161.62 275.23 160.42 275.15 159.13 275.03C158.44 274.97 158.02 274.55 157.95 273.86C157.91 273.46 157.89 273.05 157.87 272.61C157.85 272.26 157.84 271.91 157.81 271.56C157.77 271.08 157.43 270.6 156.99 270.39C156.05 269.94 155.11 269.51 154.13 269.06L153.3 268.68L152.79 268.44L152.32 268.76L151.78 269.13L150.51 269.99C150.22 270.18 149.94 270.28 149.67 270.28C149.32 270.28 148.99 270.11 148.69 269.77C148.15 269.16 147.62 268.54 147.1 267.93L146.39 267.1C145.87 266.5 145.88 265.85 146.41 265.27L146.8 264.84C147.11 264.5 147.42 264.15 147.74 263.82C148.16 263.39 148.26 262.88 148.06 262.28C147.86 261.72 147.67 261.15 147.48 260.58C147.28 259.99 147.09 259.41 146.88 258.83C146.72 258.37 146.29 257.97 145.83 257.87C145.24 257.73 144.66 257.63 144.09 257.54C143.15 257.38 142.76 256.89 142.82 255.95C142.9 254.76 142.99 253.58 143.08 252.39C143.13 251.8 143.6 251.32 144.18 251.28C144.82 251.23 145.49 251.2 146.16 251.19C146.78 251.18 147.23 250.88 147.5 250.31C147.78 249.72 148.07 249.13 148.36 248.54C148.6 248.05 148.84 247.56 149.08 247.07C149.25 246.71 149.3 246.14 149.02 245.69C148.69 245.17 148.34 244.66 148 244.18L147.95 244.1C147.52 243.48 147.58 242.85 148.1 242.37C148.67 241.85 149.26 241.34 149.85 240.84C150.14 240.59 150.43 240.34 150.71 240.09C151.05 239.79 151.4 239.64 151.74 239.64C152.21 239.64 152.56 239.92 152.78 240.16C153.16 240.57 153.57 240.92 154.01 241.29C154.25 241.49 154.6 241.61 154.93 241.61C155.13 241.61 155.32 241.57 155.49 241.48C156.67 240.88 157.92 240.53 158.98 240.28C159.52 240.15 159.9 239.65 160 239.22C160.12 238.69 160.23 238.16 160.32 237.65L160.37 237.39C160.51 236.67 160.96 236.28 161.65 236.28M162.2 263.9C166.51 263.9 170.13 260.51 170.43 256.17C170.58 253.97 169.87 251.84 168.41 250.17C166.96 248.5 164.94 247.5 162.75 247.35C162.56 247.34 162.37 247.33 162.19 247.33C157.84 247.33 154.21 250.72 153.92 255.04C153.62 259.6 157.08 263.56 161.64 263.88C161.83 263.89 162.02 263.9 162.21 263.9M181.3 186.6C179.62 186.6 177.94 186.63 176.26 186.68C175.12 186.72 174.24 187.62 174.14 188.75C174.05 189.66 173.96 190.57 173.85 191.48C173.83 191.62 173.7 191.82 173.58 191.85C171.95 192.36 170.39 193.03 168.9 193.93C168.09 193.31 167.31 192.7 166.53 192.11C166.07 191.76 165.56 191.57 165.05 191.57C164.51 191.57 163.98 191.78 163.54 192.22C162.19 193.54 160.88 194.89 159.59 196.26C158.86 197.04 158.88 198.28 159.57 199.17C160.14 199.9 160.73 200.62 161.33 201.33C161.48 201.51 161.53 201.65 161.41 201.87C160.69 203.19 160.16 204.58 159.77 206.03C159.71 206.25 159.64 206.34 159.4 206.37C158.47 206.47 157.54 206.6 156.6 206.73C155.35 206.9 154.54 207.78 154.54 209.04C154.54 210.52 154.57 212 154.59 213.49C154.59 213.89 154.61 214.29 154.65 214.69C154.75 215.79 155.68 216.57 156.76 216.68C157.7 216.77 158.63 216.88 159.57 216.96C159.78 216.98 159.88 217.05 159.94 217.25C160.37 218.73 160.99 220.14 161.77 221.47C161.88 221.65 161.88 221.77 161.74 221.94C161.12 222.72 160.52 223.52 159.91 224.31C159.12 225.34 159.2 226.58 160.14 227.5C161.37 228.7 162.6 229.9 163.83 231.1C164.34 231.59 164.92 231.84 165.5 231.84C166.02 231.84 166.56 231.64 167.05 231.24C167.79 230.65 168.52 230.06 169.24 229.45C169.39 229.32 169.51 229.26 169.65 229.26C169.75 229.26 169.86 229.29 169.99 229.36C171.31 230.07 172.71 230.6 174.16 230.98C174.39 231.04 174.47 231.12 174.5 231.35C174.62 232.38 174.75 233.41 174.9 234.43C175.08 235.67 175.88 236.43 177.14 236.45C177.53 236.45 177.91 236.46 178.3 236.46C179.51 236.46 180.71 236.43 181.92 236.42C181.94 236.42 181.97 236.42 181.99 236.42C182.09 236.42 182.2 236.42 182.3 236.42C182.45 236.42 182.6 236.42 182.75 236.4C183.89 236.28 184.72 235.44 184.84 234.28C184.95 233.23 185.06 232.18 185.15 231.13C185.17 230.87 185.28 230.78 185.52 230.68C186.82 230.14 188.11 229.57 189.39 228.99C189.49 228.94 189.58 228.92 189.66 228.92C189.77 228.92 189.86 228.96 189.97 229.05C190.76 229.68 191.56 230.3 192.36 230.91C192.84 231.28 193.36 231.47 193.88 231.47C194.49 231.47 195.08 231.21 195.59 230.7C196.75 229.51 197.92 228.32 199.07 227.13C200.17 225.99 200.21 224.88 199.22 223.66C198.61 222.91 198 222.15 197.38 221.4C197.23 221.22 197.2 221.09 197.3 220.86C197.83 219.6 198.34 218.33 198.84 217.07C198.92 216.87 199 216.77 199.24 216.74C200.35 216.61 201.46 216.45 202.57 216.3C203.57 216.16 204.44 215.19 204.43 214.16C204.42 212.33 204.39 210.5 204.35 208.68C204.32 207.42 203.51 206.56 202.24 206.41C201.28 206.3 200.31 206.2 199.35 206.11C199.09 206.09 198.97 206.01 198.9 205.74C198.51 204.31 197.95 202.94 197.22 201.64C197.1 201.43 197.11 201.29 197.26 201.1C197.9 200.3 198.52 199.48 199.13 198.66C199.79 197.77 199.75 196.56 198.97 195.76C197.66 194.43 196.32 193.12 194.96 191.84C194.54 191.44 194.01 191.25 193.48 191.25C192.98 191.25 192.48 191.42 192.06 191.74C191.29 192.33 190.55 192.96 189.79 193.56C189.72 193.62 189.58 193.66 189.48 193.66C189.44 193.66 189.4 193.66 189.37 193.64C187.82 192.79 186.2 192.13 184.47 191.68C184.34 190.67 184.2 189.65 184.08 188.64C183.93 187.48 183.04 186.61 181.87 186.61C181.68 186.61 181.49 186.61 181.31 186.61L181.3 186.6ZM179.44 220.24C179.3 220.24 179.17 220.24 179.03 220.24C173.92 220 170.15 215.71 170.5 210.73C170.83 206.05 174.75 202.44 179.38 202.44C179.59 202.44 179.8 202.44 180.01 202.46C184.86 202.8 188.63 207.11 188.24 211.96C187.85 216.79 183.95 220.24 179.44 220.24ZM138.12 208.86C137.96 208.86 137.79 208.88 137.62 208.91C136.91 209.04 136.21 209.18 135.5 209.32C134.29 209.56 133.53 210.54 133.61 211.77C133.64 212.2 133.81 212.7 133.65 213.03C133.49 213.35 132.97 213.48 132.62 213.72C132.07 214.09 131.52 214.47 131 214.88C130.88 214.97 130.79 215.02 130.69 215.02C130.61 215.02 130.53 214.99 130.43 214.93C130.12 214.74 129.8 214.59 129.47 214.43C129.14 214.27 128.79 214.19 128.45 214.19C127.77 214.19 127.12 214.5 126.68 215.1C126.19 215.77 125.71 216.45 125.27 217.16C124.67 218.11 124.83 219.21 125.65 220C125.94 220.28 126.25 220.54 126.56 220.79C126.73 220.93 126.77 221.05 126.72 221.28C126.51 222.18 126.32 223.09 126.16 224C126.12 224.25 126.03 224.35 125.8 224.41C125.4 224.52 125 224.65 124.62 224.79C123.61 225.16 123.02 226.11 123.17 227.18C123.28 227.99 123.44 228.79 123.61 229.59C123.84 230.71 124.75 231.42 125.87 231.42C125.95 231.42 126.03 231.42 126.11 231.41C126.47 231.38 126.83 231.38 127.19 231.33C127.22 231.33 127.25 231.33 127.28 231.33C127.46 231.33 127.53 231.43 127.63 231.59C128.13 232.38 128.65 233.17 129.19 233.94C129.33 234.13 129.33 234.25 129.23 234.45C128.95 235.05 128.62 235.63 128.46 236.26C128.21 237.21 128.64 237.96 129.41 238.51C130.04 238.96 130.67 239.4 131.33 239.82C131.71 240.06 132.13 240.18 132.55 240.18C133.13 240.18 133.71 239.95 134.14 239.5C134.46 239.16 134.77 238.8 135.07 238.44C135.18 238.31 135.27 238.25 135.42 238.25C135.47 238.25 135.53 238.25 135.59 238.27C136.53 238.49 137.49 238.64 138.43 238.84C138.56 238.87 138.72 238.99 138.76 239.1C138.92 239.51 139.03 239.94 139.17 240.36C139.5 241.4 140.32 242.01 141.34 242.01C141.49 242.01 141.65 242 141.81 241.97C142.55 241.84 143.28 241.7 144.01 241.55C145.11 241.32 145.82 240.48 145.86 239.3C145.83 238.85 145.82 238.31 145.76 237.78C145.73 237.53 145.8 237.42 146.01 237.29C146.76 236.82 147.49 236.33 148.22 235.82C148.32 235.75 148.41 235.71 148.5 235.71C148.58 235.71 148.65 235.74 148.74 235.79C149.1 236 149.47 236.18 149.84 236.37C150.23 236.57 150.62 236.67 151 236.67C151.71 236.67 152.38 236.33 152.85 235.67C153.31 235.03 153.78 234.39 154.2 233.73C154.81 232.77 154.62 231.59 153.76 230.83C153.41 230.52 153.04 230.23 152.7 229.89C152.6 229.79 152.53 229.58 152.56 229.44C152.72 228.6 152.94 227.77 153.1 226.93C153.14 226.7 153.23 226.6 153.44 226.54C153.88 226.42 154.31 226.28 154.75 226.14C155.87 225.77 156.49 224.72 156.28 223.57C156.15 222.84 156.02 222.1 155.87 221.37C155.63 220.19 154.77 219.48 153.62 219.48C153.53 219.48 153.44 219.48 153.35 219.49C152.95 219.53 152.55 219.57 152.15 219.57C152.04 219.57 151.88 219.47 151.82 219.37C151.3 218.57 150.8 217.76 150.28 216.96C150.16 216.78 150.13 216.65 150.24 216.45C150.52 215.94 150.8 215.43 150.99 214.88C151.29 214 150.95 213.03 150.2 212.48C149.53 211.99 148.84 211.52 148.14 211.07C147.77 210.83 147.35 210.71 146.93 210.71C146.37 210.71 145.81 210.92 145.38 211.34C145.06 211.65 144.78 211.99 144.5 212.34C144.39 212.47 144.29 212.53 144.16 212.53C144.1 212.53 144.04 212.53 143.97 212.5C142.99 212.26 142 212.04 141.01 211.85C140.77 211.8 140.65 211.73 140.59 211.49C140.51 211.15 140.39 210.83 140.28 210.5C139.94 209.48 139.11 208.88 138.11 208.88L138.12 208.86ZM139.63 231.22C139.51 231.22 139.38 231.22 139.25 231.21C136.08 231.02 133.6 228.25 133.7 225.18C133.8 222.09 136.3 219.39 139.64 219.39C139.75 219.39 139.86 219.39 139.97 219.39C143.22 219.56 145.73 222.4 145.54 225.65C145.35 228.82 142.77 231.21 139.62 231.21L139.63 231.22ZM161.66 235.28C160.5 235.28 159.62 236.02 159.39 237.2C159.28 237.8 159.17 238.4 159.03 238.99C159 239.11 158.86 239.28 158.75 239.31C157.47 239.62 156.21 239.99 155.03 240.6C155 240.61 154.96 240.62 154.92 240.62C154.82 240.62 154.7 240.58 154.64 240.53C154.25 240.2 153.85 239.87 153.51 239.5C153.02 238.96 152.39 238.66 151.73 238.66C151.17 238.66 150.59 238.88 150.04 239.35C149.16 240.11 148.27 240.86 147.41 241.64C146.5 242.47 146.4 243.65 147.11 244.68C147.47 245.19 147.82 245.7 148.15 246.23C148.22 246.33 148.21 246.54 148.15 246.65C147.63 247.73 147.09 248.8 146.58 249.89C146.47 250.12 146.36 250.19 146.12 250.19C145.44 250.2 144.76 250.24 144.09 250.29C143.01 250.37 142.16 251.24 142.07 252.32C141.98 253.51 141.89 254.7 141.81 255.89C141.71 257.35 142.46 258.29 143.91 258.53C144.47 258.62 145.03 258.72 145.58 258.85C145.71 258.88 145.87 259.04 145.92 259.17C146.32 260.32 146.7 261.47 147.1 262.62C147.17 262.83 147.18 262.95 147.01 263.12C146.54 263.59 146.11 264.1 145.66 264.59C144.79 265.54 144.77 266.76 145.62 267.74C146.39 268.63 147.15 269.53 147.93 270.41C148.43 270.98 149.03 271.26 149.66 271.26C150.12 271.26 150.6 271.11 151.06 270.8C151.7 270.37 152.34 269.93 152.88 269.57C154.16 270.16 155.37 270.71 156.57 271.28C156.69 271.34 156.81 271.5 156.82 271.63C156.88 272.4 156.88 273.18 156.96 273.95C157.08 275.11 157.89 275.91 159.05 276.01C160.28 276.12 161.51 276.21 162.74 276.27C162.79 276.27 162.84 276.27 162.88 276.27C164.05 276.27 164.9 275.54 165.13 274.37C165.27 273.68 165.4 272.98 165.52 272.29C165.57 272.02 165.68 271.89 165.97 271.8C167.04 271.47 168.09 271.08 169.15 270.73C169.19 270.72 169.24 270.71 169.29 270.71C169.41 270.71 169.53 270.74 169.6 270.8C170.14 271.27 170.66 271.78 171.19 272.26C171.69 272.71 172.24 272.93 172.79 272.93C173.34 272.93 173.86 272.72 174.35 272.3C175.26 271.53 176.16 270.75 177.05 269.96C177.97 269.15 178.13 268.06 177.47 267.01C177.06 266.35 176.62 265.71 176.19 265.07C176.07 264.9 176.08 264.78 176.19 264.6C176.69 263.66 177.19 262.72 177.64 261.76C177.78 261.46 177.94 261.38 178.23 261.37C178.95 261.34 179.67 261.32 180.39 261.27C181.52 261.19 182.38 260.34 182.47 259.21C182.56 258.04 182.65 256.86 182.73 255.69C182.83 254.22 182.1 253.29 180.65 253.03C180.09 252.93 179.53 252.82 178.97 252.73C178.7 252.68 178.57 252.57 178.49 252.28C178.18 251.18 177.83 250.08 177.45 249C177.36 248.73 177.38 248.58 177.57 248.38C178.05 247.88 178.52 247.37 178.97 246.85C179.68 246.04 179.73 244.81 179.04 243.98C178.2 242.97 177.34 241.97 176.46 241C176.02 240.52 175.45 240.27 174.85 240.27C174.43 240.27 174.01 240.39 173.62 240.64C173.07 240.99 172.53 241.36 172 241.74C171.89 241.82 171.8 241.85 171.71 241.85C171.62 241.85 171.53 241.82 171.42 241.76C170.31 241.16 169.19 240.59 168.06 240.05C167.79 239.92 167.65 239.79 167.65 239.48C167.65 238.9 167.62 238.32 167.59 237.74C167.53 236.53 166.66 235.64 165.45 235.55C164.25 235.46 163.04 235.37 161.84 235.29C161.77 235.29 161.71 235.29 161.65 235.29L161.66 235.28ZM162.21 262.9C162.04 262.9 161.88 262.9 161.71 262.88C157.69 262.6 154.65 259.12 154.92 255.11C155.17 251.31 158.42 248.34 162.19 248.34C162.35 248.34 162.52 248.34 162.69 248.36C166.69 248.64 169.72 252.12 169.45 256.11C169.18 259.95 165.99 262.91 162.22 262.91L162.21 262.9Z",
    fill: "url(#paint3_linear_1_150)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.031 317.73C375.941 317.73 376.671 318.47 376.671 319.37C376.671 320.27 375.931 321.01 375.031 321.01C374.131 321.01 373.391 320.27 373.391 319.37C373.391 318.47 374.131 317.73 375.031 317.73Z",
    fill: "#C27DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.031 344.1C375.941 344.1 376.671 344.84 376.671 345.74C376.671 346.64 375.931 347.38 375.031 347.38C374.131 347.38 373.391 346.64 373.391 345.74C373.391 344.84 374.131 344.1 375.031 344.1Z",
    fill: "#C27DFF"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M395 267.7H418.01C420.77 267.7 423.32 266.23 424.7 263.84L462.59 198.21C463.97 195.82 463.97 192.88 462.59 190.49L424.7 124.86C423.32 122.47 420.77 121 418.01 121",
    stroke: "url(#paint4_linear_1_150)",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M392.964 254.176C393.164 253.386 392.804 252.526 392.054 252.146L390.204 251.196C389.324 250.746 388.244 251.096 387.794 251.976L385.164 257.106L378.834 253.856C378.334 253.596 377.724 253.796 377.464 254.296C377.204 254.796 377.404 255.406 377.904 255.666L384.234 258.916L380.814 265.586L374.484 262.336C373.984 262.076 373.374 262.276 373.114 262.776C372.854 263.276 373.054 263.886 373.554 264.146L379.884 267.396L377.684 271.696C377.234 272.576 377.584 273.656 378.464 274.106L380.314 275.056C381.094 275.456 382.034 275.226 382.544 274.546C388.134 277.286 394.914 275.066 397.774 269.496C400.634 263.926 398.474 257.116 392.964 254.176Z",
    fill: "url(#paint5_linear_1_150)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M172.54 141.208H151.82C149.06 141.208 146.51 142.678 145.13 145.068L107.24 210.698C105.86 213.088 105.86 216.028 107.24 218.418L145.13 284.048C146.51 286.438 149.06 287.908 151.82 287.908",
    stroke: "url(#paint6_linear_1_150)",
    strokeWidth: 1.34,
    strokeMiterlimit: 10
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.899 135.228C180.429 134.608 181.329 134.408 182.089 134.798L183.929 135.768C184.799 136.228 185.139 137.308 184.679 138.178L174.399 157.828C173.939 158.698 172.859 159.038 171.989 158.578L170.149 157.608C169.369 157.198 169.019 156.298 169.279 155.488C163.809 152.498 161.719 145.678 164.619 140.138C167.519 134.588 174.329 132.418 179.899 135.228Z",
    fill: "url(#paint7_linear_1_150)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2038 256.606C27.6221 256.606 28.9486 257.367 29.6549 258.59L36.8559 271.016C37.5679 272.239 37.5679 273.761 36.8559 274.984L29.6549 287.41C28.9429 288.633 27.6221 289.394 26.2038 289.394H11.7962C10.3779 289.394 9.05139 288.633 8.34508 287.41L1.14417 274.984C0.43212 273.761 0.43212 272.239 1.14417 271.016L8.34508 258.59C9.05713 257.367 10.3779 256.606 11.7962 256.606H26.2038ZM26.2038 256H11.7962C10.1539 256 8.63794 256.869 7.81678 258.287L0.615867 270.713C-0.205289 272.131 -0.205289 273.869 0.615867 275.287L7.81678 287.713C8.63794 289.131 10.1539 290 11.7962 290H26.2038C27.8461 290 29.3621 289.131 30.1832 287.713L37.3841 275.287C38.2053 273.869 38.2053 272.131 37.3841 270.713L30.1832 258.287C29.3621 256.869 27.8461 256 26.2038 256Z",
    fill: "url(#paint8_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M325.849 349.08C328.319 349.08 330.629 350.41 331.859 352.55L344.399 374.28C345.639 376.42 345.639 379.08 344.399 381.22L331.859 402.95C330.619 405.09 328.319 406.42 325.849 406.42H300.759C298.289 406.42 295.979 405.09 294.749 402.95L282.209 381.22C280.969 379.08 280.969 376.42 282.209 374.28L294.749 352.55C295.989 350.41 298.289 349.08 300.759 349.08H325.849ZM325.849 348.02H300.759C297.899 348.02 295.259 349.54 293.829 352.02L281.289 373.75C279.859 376.23 279.859 379.27 281.289 381.75L293.829 403.48C295.259 405.96 297.899 407.48 300.759 407.48H325.849C328.709 407.48 331.349 405.96 332.779 403.48L345.319 381.75C346.749 379.27 346.749 376.23 345.319 373.75L332.779 352.02C331.349 349.54 328.709 348.02 325.849 348.02Z",
    fill: "url(#paint9_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M325.849 285.06C328.319 285.06 330.629 286.39 331.859 288.53L344.399 310.26C345.639 312.4 345.639 315.06 344.399 317.2L331.859 338.93C330.619 341.07 328.319 342.4 325.849 342.4H300.759C298.289 342.4 295.979 341.07 294.749 338.93L282.209 317.2C280.969 315.06 280.969 312.4 282.209 310.26L294.749 288.53C295.989 286.39 298.289 285.06 300.759 285.06H325.849ZM325.849 284H300.759C297.899 284 295.259 285.52 293.829 288L281.289 309.73C279.859 312.21 279.859 315.25 281.289 317.73L293.829 339.46C295.259 341.94 297.899 343.46 300.759 343.46H325.849C328.709 343.46 331.349 341.94 332.779 339.46L345.319 317.73C346.749 315.25 346.749 312.21 345.319 309.73L332.779 288C331.349 285.52 328.709 284 325.849 284Z",
    fill: "url(#paint10_linear_1_150)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M516.633 213.06C519.103 213.06 521.412 214.39 522.642 216.53L535.183 238.26C536.423 240.4 536.423 243.06 535.183 245.2L522.642 266.93C521.402 269.07 519.103 270.4 516.633 270.4H491.543C489.073 270.4 486.763 269.07 485.533 266.93L472.993 245.2C471.753 243.06 471.753 240.4 472.993 238.26L485.533 216.53C486.773 214.39 489.073 213.06 491.543 213.06H516.633ZM516.633 212H491.543C488.683 212 486.043 213.52 484.613 216L472.072 237.73C470.643 240.21 470.643 243.25 472.072 245.73L484.613 267.46C486.043 269.94 488.683 271.46 491.543 271.46H516.633C519.493 271.46 522.133 269.94 523.563 267.46L536.103 245.73C537.533 243.25 537.533 240.21 536.103 237.73L523.563 216C522.133 213.52 519.493 212 516.633 212Z",
    fill: "url(#paint11_linear_1_150)",
    fillOpacity: 0.3
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M332.32 35H292.12C289.26 35 286.62 36.52 285.19 39L265.09 73.81C263.66 76.29 263.66 79.33 265.09 81.81L285.19 116.62C286.62 119.1 289.26 120.62 292.12 120.62H332.32C335.18 120.62 337.82 119.1 339.25 116.62L359.35 81.81C360.78 79.33 360.78 76.29 359.35 73.81L339.25 39C337.82 36.52 335.18 35 332.32 35Z",
    fill: "url(#paint12_linear_1_150)",
    fillOpacity: 0.1,
    stroke: "url(#paint13_linear_1_150)",
    strokeWidth: 1.52,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 50.32H165.33V103.65H280.35V50.32Z",
    fill: "url(#paint14_linear_1_150)",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 60.79H134V93.17H280.35V60.79Z",
    fill: "url(#paint15_linear_1_150)",
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 53H188.67V58.63H280.35V53Z",
    fill: "url(#paint16_linear_1_150)",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 67.22H152.15V72.85H280.35V67.22Z",
    fill: "url(#paint17_linear_1_150)",
    fillOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 76.29H181.26V81.92H280.35V76.29Z",
    fill: "url(#paint18_linear_1_150)",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.35 95.34H168.91V100.97H280.35V95.34Z",
    fill: "url(#paint19_linear_1_150)",
    fillOpacity: 0.5
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M412.303 103H372.102C369.242 103 366.603 104.52 365.173 107L345.072 141.81C343.643 144.29 343.643 147.33 345.072 149.81L365.173 184.62C366.603 187.1 369.242 188.62 372.102 188.62H412.303C415.163 188.62 417.803 187.1 419.233 184.62L439.333 149.81C440.763 147.33 440.763 144.29 439.333 141.81L419.233 107C417.803 104.52 415.163 103 412.303 103Z",
    fill: "url(#paint20_linear_1_150)",
    stroke: "url(#paint21_linear_1_150)",
    strokeWidth: 1.52,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.102 326.62H168.303C171.163 326.62 173.803 325.1 175.233 322.62L195.333 287.81C196.763 285.33 196.763 282.29 195.333 279.81L175.233 245C173.803 242.52 171.163 241 168.303 241H128.102C125.242 241 122.602 242.52 121.172 245L101.072 279.81C99.6425 282.29 99.6425 285.33 101.072 287.81L121.172 322.62C122.602 325.1 125.242 326.62 128.102 326.62Z",
    fill: "url(#paint22_linear_1_150)",
    stroke: "url(#paint23_linear_1_150)",
    strokeWidth: 1.52,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.286 142H226.714C224.238 142 221.953 143.309 220.715 145.445L182.928 210.555C181.691 212.691 181.691 215.309 182.928 217.445L220.715 282.555C221.953 284.691 224.238 286 226.714 286H302.286C304.762 286 307.047 284.691 308.285 282.555L346.072 217.445C347.309 215.309 347.309 212.691 346.072 210.555L308.285 145.445C307.047 143.309 304.762 142 302.286 142Z",
    fill: "url(#paint24_linear_1_150)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.286 142H226.714C224.238 142 221.953 143.309 220.715 145.445L182.928 210.555C181.691 212.691 181.691 215.309 182.928 217.445L220.715 282.555C221.953 284.691 224.238 286 226.714 286H302.286C304.762 286 307.047 284.691 308.285 282.555L346.072 217.445C347.309 215.309 347.309 212.691 346.072 210.555L308.285 145.445C307.047 143.309 304.762 142 302.286 142Z",
    stroke: "url(#paint25_linear_1_150)",
    strokeWidth: 1.52,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.669 99.59H230.619C228.962 99.59 227.619 100.933 227.619 102.59V111.11C227.619 112.767 228.962 114.11 230.619 114.11H281.669C283.326 114.11 284.669 112.767 284.669 111.11V102.59C284.669 100.933 283.326 99.59 281.669 99.59Z",
    fill: "url(#paint26_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 99.59H230.619C228.962 99.59 227.619 100.933 227.619 102.59V111.11C227.619 112.767 228.962 114.11 230.619 114.11H281.669C283.326 114.11 284.669 112.767 284.669 111.11V102.59C284.669 100.933 283.326 99.59 281.669 99.59Z",
    stroke: "black",
    strokeWidth: 1.14,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.669 85.07H230.619C228.962 85.07 227.619 86.4132 227.619 88.07V96.59C227.619 98.2469 228.962 99.59 230.619 99.59H281.669C283.326 99.59 284.669 98.2469 284.669 96.59V88.07C284.669 86.4132 283.326 85.07 281.669 85.07Z",
    fill: "url(#paint27_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 85.07H230.619C228.962 85.07 227.619 86.4132 227.619 88.07V96.59C227.619 98.2469 228.962 99.59 230.619 99.59H281.669C283.326 99.59 284.669 98.2469 284.669 96.59V88.07C284.669 86.4132 283.326 85.07 281.669 85.07Z",
    stroke: "black",
    strokeWidth: 1.14,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.669 70.56H230.619C228.962 70.56 227.619 71.9031 227.619 73.56V82.08C227.619 83.7368 228.962 85.08 230.619 85.08H281.669C283.326 85.08 284.669 83.7368 284.669 82.08V73.56C284.669 71.9031 283.326 70.56 281.669 70.56Z",
    fill: "url(#paint28_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 70.56H230.619C228.962 70.56 227.619 71.9031 227.619 73.56V82.08C227.619 83.7368 228.962 85.08 230.619 85.08H281.669C283.326 85.08 284.669 83.7368 284.669 82.08V73.56C284.669 71.9031 283.326 70.56 281.669 70.56Z",
    stroke: "black",
    strokeWidth: 1.14,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.669 56.04H230.619C228.962 56.04 227.619 57.3832 227.619 59.04V67.56C227.619 69.2169 228.962 70.56 230.619 70.56H281.669C283.326 70.56 284.669 69.2169 284.669 67.56V59.04C284.669 57.3832 283.326 56.04 281.669 56.04Z",
    fill: "url(#paint29_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 56.04H230.619C228.962 56.04 227.619 57.3832 227.619 59.04V67.56C227.619 69.2169 228.962 70.56 230.619 70.56H281.669C283.326 70.56 284.669 69.2169 284.669 67.56V59.04C284.669 57.3832 283.326 56.04 281.669 56.04Z",
    stroke: "black",
    strokeWidth: 1.14,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.669 41.52H230.619C228.962 41.52 227.619 42.8632 227.619 44.52V53.04C227.619 54.6969 228.962 56.04 230.619 56.04H281.669C283.326 56.04 284.669 54.6969 284.669 53.04V44.52C284.669 42.8632 283.326 41.52 281.669 41.52Z",
    fill: "url(#paint30_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.669 41.52H230.619C228.962 41.52 227.619 42.8632 227.619 44.52V53.04C227.619 54.6969 228.962 56.04 230.619 56.04H281.669C283.326 56.04 284.669 54.6969 284.669 53.04V44.52C284.669 42.8632 283.326 41.52 281.669 41.52Z",
    stroke: "black",
    strokeWidth: 1.14,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M268.71 49.14C268.71 49.79 268.18 50.32 267.53 50.32C266.88 50.32 266.35 49.79 266.35 49.14C266.35 48.49 266.88 47.96 267.53 47.96C268.18 47.96 268.71 48.49 268.71 49.14Z",
    fill: "url(#paint31_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M273.43 49.14C273.43 49.79 272.9 50.32 272.25 50.32C271.6 50.32 271.07 49.79 271.07 49.14C271.07 48.49 271.6 47.96 272.25 47.96C272.9 47.96 273.43 48.49 273.43 49.14Z",
    fill: "url(#paint32_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M278.139 49.14C278.139 49.79 277.609 50.32 276.959 50.32C276.309 50.32 275.779 49.79 275.779 49.14C275.779 48.49 276.309 47.96 276.959 47.96C277.609 47.96 278.139 48.49 278.139 49.14Z",
    fill: "url(#paint33_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M268.71 63.3C268.71 63.95 268.18 64.48 267.53 64.48C266.88 64.48 266.35 63.95 266.35 63.3C266.35 62.65 266.88 62.12 267.53 62.12C268.18 62.12 268.71 62.65 268.71 63.3Z",
    fill: "url(#paint34_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M273.43 63.3C273.43 63.95 272.9 64.48 272.25 64.48C271.6 64.48 271.07 63.95 271.07 63.3C271.07 62.65 271.6 62.12 272.25 62.12C272.9 62.12 273.43 62.65 273.43 63.3Z",
    fill: "url(#paint35_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M278.139 63.3C278.139 63.95 277.609 64.48 276.959 64.48C276.309 64.48 275.779 63.95 275.779 63.3C275.779 62.65 276.309 62.12 276.959 62.12C277.609 62.12 278.139 62.65 278.139 63.3Z",
    fill: "url(#paint36_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M268.71 77.46C268.71 78.11 268.18 78.64 267.53 78.64C266.88 78.64 266.35 78.11 266.35 77.46C266.35 76.81 266.88 76.28 267.53 76.28C268.18 76.28 268.71 76.81 268.71 77.46Z",
    fill: "url(#paint37_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M273.43 77.46C273.43 78.11 272.9 78.64 272.25 78.64C271.6 78.64 271.07 78.11 271.07 77.46C271.07 76.81 271.6 76.28 272.25 76.28C272.9 76.28 273.43 76.81 273.43 77.46Z",
    fill: "url(#paint38_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M278.139 77.46C278.139 78.11 277.609 78.64 276.959 78.64C276.309 78.64 275.779 78.11 275.779 77.46C275.779 76.81 276.309 76.28 276.959 76.28C277.609 76.28 278.139 76.81 278.139 77.46Z",
    fill: "url(#paint39_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M268.71 91.62C268.71 92.27 268.18 92.8 267.53 92.8C266.88 92.8 266.35 92.27 266.35 91.62C266.35 90.97 266.88 90.44 267.53 90.44C268.18 90.44 268.71 90.97 268.71 91.62Z",
    fill: "url(#paint40_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M273.43 91.62C273.43 92.27 272.9 92.8 272.25 92.8C271.6 92.8 271.07 92.27 271.07 91.62C271.07 90.97 271.6 90.44 272.25 90.44C272.9 90.44 273.43 90.97 273.43 91.62Z",
    fill: "url(#paint41_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M278.139 91.62C278.139 92.27 277.609 92.8 276.959 92.8C276.309 92.8 275.779 92.27 275.779 91.62C275.779 90.97 276.309 90.44 276.959 90.44C277.609 90.44 278.139 90.97 278.139 91.62Z",
    fill: "url(#paint42_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M268.71 105.78C268.71 106.43 268.18 106.96 267.53 106.96C266.88 106.96 266.35 106.43 266.35 105.78C266.35 105.13 266.88 104.6 267.53 104.6C268.18 104.6 268.71 105.13 268.71 105.78Z",
    fill: "url(#paint43_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M273.43 105.78C273.43 106.43 272.9 106.96 272.25 106.96C271.6 106.96 271.07 106.43 271.07 105.78C271.07 105.13 271.6 104.6 272.25 104.6C272.9 104.6 273.43 105.13 273.43 105.78Z",
    fill: "url(#paint44_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M278.139 105.78C278.139 106.43 277.609 106.96 276.959 106.96C276.309 106.96 275.779 106.43 275.779 105.78C275.779 105.13 276.309 104.6 276.959 104.6C277.609 104.6 278.139 105.13 278.139 105.78Z",
    fill: "url(#paint45_linear_1_150)"
  }), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1_150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.58 316H291.57C289.913 316 288.57 317.343 288.57 319V357.54C288.57 359.197 289.913 360.54 291.57 360.54H352.58C354.237 360.54 355.58 359.197 355.58 357.54V319C355.58 317.343 354.237 316 352.58 316Z",
    fill: "url(#paint46_linear_1_150)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.58 316.88C353.75 316.88 354.71 317.83 354.71 319.01V357.55C354.71 358.72 353.76 359.68 352.58 359.68H291.57C290.4 359.68 289.44 358.73 289.44 357.55V319.01C289.44 317.84 290.39 316.88 291.57 316.88H352.58ZM352.58 316.01H291.57C289.91 316.01 288.57 317.35 288.57 319.01V357.55C288.57 359.21 289.91 360.55 291.57 360.55H352.58C354.24 360.55 355.58 359.21 355.58 357.55V319.01C355.58 317.35 354.24 316.01 352.58 316.01Z",
    fill: "url(#paint47_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.481 318.9H293.671C292.688 318.9 291.891 319.697 291.891 320.68V355.86C291.891 356.843 292.688 357.64 293.671 357.64H350.481C351.464 357.64 352.261 356.843 352.261 355.86V320.68C352.261 319.697 351.464 318.9 350.481 318.9Z",
    fill: "url(#paint48_linear_1_150)",
    style: {
      mixBlendMode: "screen"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M350.481 318.9H293.671C292.688 318.9 291.891 319.697 291.891 320.68V355.86C291.891 356.843 292.688 357.64 293.671 357.64H350.481C351.464 357.64 352.261 356.843 352.261 355.86V320.68C352.261 319.697 351.464 318.9 350.481 318.9Z",
    stroke: "#C388FF",
    strokeWidth: 0.87,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.302 260.93C160.982 260.98 171.122 271.21 171.082 283.91C171.032 296.58 160.802 306.73 148.102 306.69C135.432 306.64 125.282 296.41 125.332 283.71C125.372 271.04 135.622 260.88 148.312 260.93H148.302ZM127.642 285.01C127.892 289.13 129.202 292.73 131.522 295.9C133.492 294.88 135.362 293.91 137.092 293.02C136.572 290.31 136.062 287.67 135.542 285.01H127.642ZM164.872 295.92C167.172 292.68 168.542 289.12 168.732 285.03H161.172C160.632 287.78 160.102 290.47 159.582 293.15C161.252 294.03 163.002 294.94 164.882 295.93L164.872 295.92ZM131.182 272.15C129.092 275.31 127.812 278.73 127.662 282.58H135.562C136.022 280.05 136.462 277.62 136.902 275.19C135.062 274.21 133.172 273.21 131.182 272.15ZM165.182 272.15C163.262 273.18 161.432 274.16 159.722 275.08C160.192 277.6 160.662 280.07 161.132 282.59H168.732C168.552 278.71 167.302 275.3 165.192 272.15H165.182ZM158.832 285.06H149.412V290.86C152.052 291.32 154.622 291.76 157.422 292.25C157.882 289.89 158.352 287.51 158.832 285.06ZM146.952 290.88V285.04H137.872C138.352 287.52 138.812 289.87 139.262 292.17C141.962 291.72 144.412 291.3 146.952 290.88ZM149.442 277.42V282.59H158.822C158.382 280.27 157.952 278.07 157.552 275.99C154.682 276.5 152.072 276.96 149.432 277.42H149.442ZM137.912 282.57H146.972V277.41C144.342 276.96 141.812 276.53 139.072 276.07C138.692 278.21 138.312 280.33 137.912 282.57ZM156.642 273.83C154.862 269.71 152.492 266.38 149.442 263.32V275.1C151.872 274.67 154.172 274.26 156.642 273.82V273.83ZM146.992 263.44C143.992 266.58 141.672 269.84 140.002 273.9C142.412 274.31 144.652 274.69 146.992 275.09V263.44ZM149.412 304.42C152.362 301.41 154.682 298.28 156.402 294.38C153.962 293.97 151.712 293.6 149.412 293.21V304.42ZM146.962 304.1V293.2C144.702 293.59 142.562 293.95 140.272 294.34C141.962 298.12 144.162 301.2 146.962 304.1ZM143.212 263.81C139.112 264.85 135.592 266.97 132.612 270.34C134.422 271.28 136.092 272.15 137.572 272.92C139.542 269.73 141.392 266.75 143.222 263.8L143.212 263.81ZM163.772 270.32C160.872 267.09 157.512 264.95 153.462 263.91C155.332 266.91 157.142 269.83 159.032 272.85C160.492 272.07 162.072 271.22 163.772 270.32ZM143.312 303.84C141.532 301.04 139.742 298.21 137.842 295.22C136.352 295.99 134.722 296.83 132.982 297.73C135.992 300.89 139.402 302.9 143.312 303.84ZM153.462 303.74C157.312 302.69 160.562 300.74 163.392 297.71C161.732 296.86 160.182 296.06 158.782 295.34C156.952 298.23 155.242 300.93 153.462 303.74Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365.012 148.75C365.142 147.43 365.432 146.16 366.032 144.97C367.262 142.5 369.162 140.77 371.722 139.75C371.932 139.66 372.022 139.56 372.042 139.32C372.342 136.72 373.572 134.67 375.872 133.39C378.392 131.98 380.932 132.09 383.392 133.63C383.512 133.7 383.632 133.78 383.772 133.87C385.652 130.15 388.512 127.55 392.502 126.3C395.322 125.42 398.172 125.49 400.992 126.39C406.672 128.2 411.282 133.95 410.832 140.76C411.242 140.84 411.662 140.9 412.062 141.02C415.822 142.08 418.312 144.43 419.182 148.27C420.182 152.71 417.812 157.23 413.662 159.07C412.392 159.63 411.072 159.91 409.682 159.91C398.302 159.91 386.932 159.94 375.552 159.89C371.142 159.87 367.952 157.73 365.982 153.8C365.442 152.71 365.152 151.54 365.062 150.33C365.062 150.25 365.032 150.17 365.012 150.1V148.76V148.75ZM384.592 137.37C384.482 137.27 384.372 137.18 384.272 137.08C383.672 136.49 383.132 135.85 382.402 135.4C380.292 134.08 377.342 134.44 375.642 136.22C374.472 137.45 374.012 138.91 374.102 140.58C374.132 141.14 374.132 141.15 373.592 141.28C369.462 142.29 366.752 146.2 367.262 150.44C367.752 154.55 371.292 157.73 375.442 157.73C386.852 157.73 398.262 157.73 409.662 157.73C411.442 157.73 413.042 157.18 414.442 156.06C416.872 154.11 417.852 150.73 416.822 147.78C415.762 144.75 412.992 142.76 409.792 142.72C409.352 142.72 408.902 142.72 408.432 142.72C408.452 142.57 408.462 142.45 408.482 142.33C408.652 141.18 408.762 140.04 408.642 138.88C408.372 136.06 407.282 133.6 405.302 131.6C402.212 128.47 398.442 127.27 394.142 128.14C390.092 128.96 387.212 131.38 385.482 135.13C385.152 135.85 384.902 136.62 384.612 137.38L384.592 137.37Z",
    fill: "url(#paint49_linear_1_150)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M396.542 125.67C395.192 125.67 393.842 125.87 392.492 126.3C388.502 127.55 385.652 130.15 383.762 133.87C383.622 133.78 383.502 133.7 383.382 133.63C382.082 132.81 380.762 132.4 379.422 132.4C378.242 132.4 377.052 132.73 375.862 133.39C373.562 134.67 372.332 136.72 372.032 139.32C372.002 139.56 371.922 139.66 371.712 139.75C369.162 140.77 367.252 142.5 366.022 144.97C365.432 146.16 365.142 147.44 365.002 148.75V150.09C365.022 150.17 365.042 150.25 365.052 150.32C365.142 151.54 365.432 152.71 365.972 153.79C367.942 157.72 371.132 159.86 375.542 159.88C380.402 159.9 385.272 159.91 390.132 159.91C395.982 159.91 401.832 159.91 407.682 159.91C408.342 159.91 409.002 159.91 409.662 159.91C411.052 159.91 412.372 159.63 413.642 159.07C417.792 157.23 420.162 152.7 419.162 148.27C418.292 144.43 415.802 142.08 412.042 141.02C411.642 140.91 411.222 140.85 410.812 140.76C411.262 133.95 406.652 128.2 400.972 126.39C399.492 125.92 398.012 125.67 396.532 125.67H396.542ZM384.592 137.37C384.882 136.61 385.132 135.84 385.462 135.12C387.202 131.37 390.072 128.95 394.122 128.13C395.032 127.95 395.922 127.85 396.782 127.85C399.992 127.85 402.852 129.12 405.282 131.59C407.262 133.6 408.352 136.06 408.622 138.87C408.732 140.03 408.622 141.18 408.462 142.32C408.442 142.44 408.432 142.56 408.412 142.71C408.712 142.71 409.002 142.71 409.282 142.71C409.442 142.71 409.612 142.71 409.772 142.71C412.982 142.75 415.742 144.74 416.802 147.77C417.832 150.72 416.852 154.1 414.422 156.05C413.022 157.17 411.432 157.72 409.642 157.72C403.462 157.72 397.282 157.72 391.102 157.72C385.872 157.72 380.642 157.72 375.412 157.72C371.262 157.72 367.732 154.53 367.232 150.43C366.722 146.2 369.432 142.28 373.562 141.27C374.102 141.14 374.102 141.13 374.072 140.57C373.982 138.9 374.442 137.43 375.612 136.21C376.622 135.15 378.072 134.59 379.532 134.59C380.522 134.59 381.522 134.85 382.372 135.38C383.102 135.83 383.642 136.48 384.242 137.06C384.342 137.16 384.452 137.25 384.562 137.35L384.592 137.37Z",
    fill: "url(#paint50_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M428.621 318.9H291.891V357.64H428.621V318.9Z",
    fill: "url(#paint51_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M428.621 326.51H291.891V350.03H428.621V326.51Z",
    fill: "url(#paint52_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M417.401 320.85H291.891V324.94H417.401V320.85Z",
    fill: "url(#paint53_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M409.361 331.18H291.891V335.27H409.361V331.18Z",
    fill: "url(#paint54_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M439.681 337.76H291.891V341.85H439.681V337.76Z",
    fill: "url(#paint55_linear_1_150)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M440.791 351.6H291.891V355.69H440.791V351.6Z",
    fill: "url(#paint56_linear_1_150)"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M252.388 226L250.076 218.554H241.066L238.788 226H236.782L244.296 202.268H246.88L254.394 226H252.388ZM246.778 207.81L245.69 204.002H245.452L244.33 207.81L241.542 216.956H249.634L246.778 207.81ZM258.217 226V202.268H266.853C270.57 202.268 272.429 204.478 272.429 208.898C272.429 213.318 270.57 215.528 266.853 215.528H260.189V226H258.217ZM260.189 213.794H266.785C268.009 213.794 268.904 213.465 269.471 212.808C270.06 212.128 270.355 211.187 270.355 209.986V207.81C270.355 206.609 270.06 205.679 269.471 205.022C268.904 204.342 268.009 204.002 266.785 204.002H260.189V213.794ZM275.59 226V224.368H278.684V203.9H275.59V202.268H283.75V203.9H280.656V224.368H283.75V226H275.59Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_150",
    x: 164.5,
    y: 135.15,
    width: 200,
    height: 179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.65
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.146048 0 0 0 0 0.106583 0 0 0 0 0.36639 0 0 0 0.65 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1_150",
    x: 215.469,
    y: 95.16,
    width: 81.35,
    height: 38.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.72
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.79
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.207843 0 0 0 0 0.498039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1_150",
    x: 215.469,
    y: 80.64,
    width: 81.35,
    height: 38.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.72
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.79
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.207843 0 0 0 0 0.498039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1_150",
    x: 215.469,
    y: 66.13,
    width: 81.35,
    height: 38.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.72
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.79
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.207843 0 0 0 0 0.498039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1_150",
    x: 215.469,
    y: 51.61,
    width: 81.35,
    height: 38.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.72
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.79
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.207843 0 0 0 0 0.498039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1_150",
    x: 215.469,
    y: 37.09,
    width: 81.35,
    height: 38.82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.72
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.79
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.188235 0 0 0 0 0.207843 0 0 0 0 0.498039 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1_150",
    x: 273.52,
    y: 312.51,
    width: 97.13,
    height: 79.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.99
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.211765 0 0 0 0 0.556863 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_150"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_150",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_150",
    x1: 233.202,
    y1: 318.16,
    x2: 233.202,
    y2: 402.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8642FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5124D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_150",
    x1: 233.202,
    y1: 317.23,
    x2: 233.202,
    y2: 404.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7346E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_150",
    x1: 42.16,
    y1: -26.09,
    x2: 48.55,
    y2: 64.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376ED0",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4991EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_150",
    x1: 166.24,
    y1: 185.46,
    x2: 159.85,
    y2: 276.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#376ED0",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4991EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_150",
    x1: 429.64,
    y1: 268.37,
    x2: 429.64,
    y2: 120.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B84AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6AA6E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EB1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_150",
    x1: 399.135,
    y1: 256.994,
    x2: 376.278,
    y2: 268.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEF6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#99EEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#62DCF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26C7F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_150",
    x1: 139.04,
    y1: 140.538,
    x2: 139.04,
    y2: 288.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#6C4FD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D26B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_150",
    x1: 182.141,
    y1: 141.459,
    x2: 163.059,
    y2: 151.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B5CFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_150",
    x1: 19.0029,
    y1: 289.994,
    x2: 19.0029,
    y2: 256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#559DCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71AAE6",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_150",
    x1: 313.299,
    y1: 407.48,
    x2: 313.299,
    y2: 348.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E50D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A06CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_150",
    x1: 71.9992,
    y1: 343.45,
    x2: 72.9992,
    y2: 284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E50D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A06CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_150",
    x1: 262.782,
    y1: 271.45,
    x2: 263.782,
    y2: 212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E50D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A06CEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_150",
    x1: 312.22,
    y1: 120.46,
    x2: 312.22,
    y2: 35.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2954BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4991EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_150",
    x1: 312.22,
    y1: 121.39,
    x2: 312.22,
    y2: 34.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004377"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_150",
    x1: 165.56,
    y1: 76.98,
    x2: 279.21,
    y2: 76.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BADF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#5CADF5",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#61ADF6",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#68AEF8",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#72AFFB",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_150",
    x1: 134.29,
    y1: 76.98,
    x2: 278.89,
    y2: 76.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BADF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#60ADF6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6EAEFA",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_150",
    x1: 188.85,
    y1: 55.81,
    x2: 279.44,
    y2: 55.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BADF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#60ADF6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6EAEFA",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_150",
    x1: 152.4,
    y1: 70.04,
    x2: 279.08,
    y2: 70.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BADF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5BADF5",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#67AEF8",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#70AEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#77AFFD",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#7BAFFE",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_150",
    x1: 181.45,
    y1: 79.1,
    x2: 279.37,
    y2: 79.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BADF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5BADF5",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#67AEF8",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#70AEFB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#77AFFD",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#7BAFFE",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_150",
    x1: 169.13,
    y1: 98.16,
    x2: 279.24,
    y2: 98.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BADF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#60ADF6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#6EAEFA",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DB0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_150",
    x1: 392.203,
    y1: 188.47,
    x2: 392.203,
    y2: 103.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000710"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_150",
    x1: 392.203,
    y1: 189.39,
    x2: 392.203,
    y2: 102.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5588E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EBFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_150",
    x1: 148.202,
    y1: 241.16,
    x2: 148.202,
    y2: 325.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F0D99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10003D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_150",
    x1: 148.202,
    y1: 240.23,
    x2: 148.202,
    y2: 327.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7346E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_150",
    x1: 264.5,
    y1: 285.724,
    x2: 264.5,
    y2: 143.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A0DBD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_150",
    x1: 327.745,
    y1: 250.327,
    x2: 201.579,
    y2: 177.113,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#26C7F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#65A8F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#C97AF7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_150",
    x1: 239.429,
    y1: 123.85,
    x2: 272.599,
    y2: 90.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18388B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1_150",
    x1: 239.429,
    y1: 109.33,
    x2: 272.599,
    y2: 75.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18388B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1_150",
    x1: 239.429,
    y1: 94.82,
    x2: 272.599,
    y2: 61.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18388B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1_150",
    x1: 239.429,
    y1: 80.3,
    x2: 272.599,
    y2: 46.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18388B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1_150",
    x1: 239.429,
    y1: 65.78,
    x2: 272.599,
    y2: 32.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060A21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18388B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1_150",
    x1: 267.53,
    y1: 50.32,
    x2: 267.53,
    y2: 47.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1_150",
    x1: 272.25,
    y1: 50.32,
    x2: 272.25,
    y2: 47.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1_150",
    x1: 276.969,
    y1: 50.32,
    x2: 276.969,
    y2: 47.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1_150",
    x1: 267.53,
    y1: 64.48,
    x2: 267.53,
    y2: 62.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1_150",
    x1: 272.25,
    y1: 64.48,
    x2: 272.25,
    y2: 62.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1_150",
    x1: 276.969,
    y1: 64.48,
    x2: 276.969,
    y2: 62.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1_150",
    x1: 267.53,
    y1: 78.64,
    x2: 267.53,
    y2: 76.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1_150",
    x1: 272.25,
    y1: 78.64,
    x2: 272.25,
    y2: 76.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1_150",
    x1: 276.969,
    y1: 78.64,
    x2: 276.969,
    y2: 76.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1_150",
    x1: 267.53,
    y1: 92.8,
    x2: 267.53,
    y2: 90.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1_150",
    x1: 272.25,
    y1: 92.8,
    x2: 272.25,
    y2: 90.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1_150",
    x1: 276.969,
    y1: 92.8,
    x2: 276.969,
    y2: 90.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1_150",
    x1: 267.53,
    y1: 106.96,
    x2: 267.53,
    y2: 104.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1_150",
    x1: 272.25,
    y1: 106.96,
    x2: 272.25,
    y2: 104.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1_150",
    x1: 276.969,
    y1: 106.96,
    x2: 276.969,
    y2: 104.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9DC6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1_150",
    x1: 322.08,
    y1: 360.45,
    x2: 322.08,
    y2: 316.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F27E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1_150",
    x1: 355.58,
    y1: 338.27,
    x2: 288.57,
    y2: 338.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C27DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#914BF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1_150",
    x1: 322.081,
    y1: 357.57,
    x2: 322.081,
    y2: 319.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1_150",
    x1: 365.012,
    y1: 142.79,
    x2: 419.392,
    y2: 142.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2954BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4991EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1_150",
    x1: 365.012,
    y1: 142.79,
    x2: 419.392,
    y2: 142.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5588E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7EBFF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1_150",
    x1: 428.361,
    y1: 338.27,
    x2: 293.251,
    y2: 338.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15BF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A25CF5",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#A761F6",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#AE68F8",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B772FB",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1_150",
    x1: 428.361,
    y1: 338.27,
    x2: 293.251,
    y2: 338.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15BF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A660F6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#B46EFA",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1_150",
    x1: 417.161,
    y1: 322.89,
    x2: 293.141,
    y2: 322.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15BF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A660F6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#B46EFA",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1_150",
    x1: 409.131,
    y1: 333.23,
    x2: 293.061,
    y2: 333.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15BF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#A15BF5",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#AC67F8",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B570FB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#BC77FD",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C07BFE",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1_150",
    x1: 439.391,
    y1: 339.81,
    x2: 293.361,
    y2: 339.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15BF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#A15BF5",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#AC67F8",
    stopOpacity: 0.36
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B570FB",
    stopOpacity: 0.64
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#BC77FD",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#C07BFE",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1_150",
    x1: 440.501,
    y1: 353.65,
    x2: 293.381,
    y2: 353.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A15BF5",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#A660F6",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#B46EFA",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C27DFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffortlessIntegrationImg);
export default __webpack_public_path__ + "static/media/EffortlessIntegrationImg.eb0e1262b91359fbda9a8cc8021c8986.svg";
export { ForwardRef as ReactComponent };